import { useEffect } from 'react';

const SEOSchema = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    // Course Schema
    const courseSchema = {
      "@context": "https://schema.org",
      "@type": "Course",
      "name": "セロトニン活性療法マスター講座",
      "description": "自律神経・慢性痛の患者さんに対応できる整体師を育成する専門講座。脳と自律神経に直接アプローチする科学的手技を3回のスクーリングで習得します。",
      "provider": {
        "@type": "Organization",
        "name": "セロトニン活性療法協会",
        "url": siteUrl,
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "中央3-15-5",
          "addressLocality": "守谷市",
          "addressRegion": "茨城県",
          "postalCode": "302-0104",
          "addressCountry": "JP"
        }
      },
      "educationalLevel": "Professional",
      "occupationalCredentialAwarded": "セロトニン活性療法マスター",
      "hasCourseInstance": {
        "@type": "CourseInstance",
        "courseMode": "onsite",
        "courseWorkload": "PT3D",
        "location": {
          "@type": "Place",
          "name": "セロトニン活性療法協会 本部",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "中央3-15-5",
            "addressLocality": "守谷市",
            "addressRegion": "茨城県",
            "postalCode": "302-0104",
            "addressCountry": "JP"
          }
        }
      },
      "offers": {
        "@type": "Offer",
        "price": "198000",
        "priceCurrency": "JPY",
        "availability": "https://schema.org/InStock",
        "priceValidUntil": "2025-12-31",
        "url": siteUrl
      },
      "teaches": [
        "セロトニン神経活性化手技",
        "自律神経調整技術",
        "脳神経アプローチ",
        "慢性痛対応技術"
      ]
    };

    // Organization Schema
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "セロトニン活性療法協会",
      "url": siteUrl,
      "logo": "https://static.readdy.ai/image/3df376879f5344c50e4413b78fe6e8bd/f4ce57a64c20728d8e278c19550390d0.png",
      "description": "脳と自律神経にアプローチする科学的整体手技の研究・教育機関",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "中央3-15-5",
        "addressLocality": "守谷市",
        "addressRegion": "茨城県",
        "postalCode": "302-0104",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "35.951572",
        "longitude": "140.045776"
      },
      "areaServed": {
        "@type": "Country",
        "name": "日本"
      }
    };

    // Medical Therapy Schema
    const medicalTherapySchema = {
      "@context": "https://schema.org",
      "@type": "MedicalTherapy",
      "name": "セロトニン活性療法",
      "description": "脳波測定・唾液セロトニン測定により科学的に検証された、脳と自律神経に直接アプローチする整体療法",
      "relevantSpecialty": {
        "@type": "MedicalSpecialty",
        "name": "自律神経・慢性痛治療"
      },
      "medicineSystem": "整体・代替医療"
    };

    // FAQ Schema
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "特別な資格や経験は必要ですか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "いいえ。整体師であれば、どなたでも習得可能です。力も必要ありません。"
          }
        },
        {
          "@type": "Question",
          "name": "強い刺激はありませんか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "ありません。リズムと軽い刺激を使うため、高齢者や女性にも安全です。"
          }
        },
        {
          "@type": "Question",
          "name": "すぐ現場で使えますか?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "はい。3回のスクーリングで、施術・説明・メニュー化まで完成します。"
          }
        },
        {
          "@type": "Question",
          "name": "分割払いは可能ですか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "はい、可能です。月16,500円〜の分割払いに対応しております。"
          }
        },
        {
          "@type": "Question",
          "name": "遠方からの参加は可能ですか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "はい、全国各地から受講者が集まっています。宿泊施設のご案内も可能です。"
          }
        },
        {
          "@type": "Question",
          "name": "修了後のサポートはありますか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "はい。修了後も質問や相談ができるサポート体制を整えております。"
          }
        }
      ]
    };

    // WebPage Schema
    const webPageSchema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "セロトニン活性療法マスター講座｜自律神経症状の整体師向け研修｜セロトニン活性療法協会",
      "description": "自律神経・慢性痛の患者さんで結果が安定しない整体師へ。脳と自律神経に直接アプローチするセロトニン活性療法マスター講座。15分で体感、科学的エビデンス、再現性の高い手技を3回のスクーリングで習得。不眠、めまい、パニック、慢性痛に対応できる整体師になりませんか。",
      "url": siteUrl,
      "inLanguage": "ja-JP",
      "isPartOf": {
        "@type": "WebSite",
        "name": "セロトニン活性療法協会",
        "url": siteUrl
      }
    };

    // Event Schema for Course Dates
    const eventSchema = {
      "@context": "https://schema.org",
      "@type": "Event",
      "name": "セロトニン活性療法マスター講座",
      "description": "自律神経・慢性痛の患者さんに対応できる整体師を育成する専門講座",
      "startDate": "2026-04-01",
      "endDate": "2026-06-03",
      "eventStatus": "https://schema.org/EventScheduled",
      "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
      "location": {
        "@type": "Place",
        "name": "セロトニン活性療法協会 本部",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "中央3-15-5",
          "addressLocality": "守谷市",
          "addressRegion": "茨城県",
          "postalCode": "302-0104",
          "addressCountry": "JP"
        }
      },
      "organizer": {
        "@type": "Organization",
        "name": "セロトニン活性療法協会",
        "url": siteUrl
      },
      "offers": {
        "@type": "Offer",
        "price": "198000",
        "priceCurrency": "JPY",
        "availability": "https://schema.org/InStock",
        "url": siteUrl,
        "validFrom": "2025-01-01"
      }
    };

    // Add all schemas to head
    const schemas = [
      courseSchema,
      organizationSchema,
      medicalTherapySchema,
      faqSchema,
      webPageSchema,
      eventSchema
    ];

    const scriptElements: HTMLScriptElement[] = [];

    schemas.forEach((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      script.id = `schema-${index}`;
      document.head.appendChild(script);
      scriptElements.push(script);
    });

    // Cleanup
    return () => {
      scriptElements.forEach(script => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, []);

  return null;
};

export default SEOSchema;
